import type { CityConfig } from "../city-template/types";

export const indianapolisConfig: CityConfig = {
  city: "Indianapolis",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "indianapolis",
  route: "/cities/indianapolis",
  title: "Emergency Passport Indianapolis IN | Expedited Passport Processing | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Indianapolis, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Indianapolis, Carmel, Fishers, Noblesville, Greenwood, and all Central Indiana residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Indianapolis, IN",
  heroSubtitle: "Indianapolis travelers — from the Indy 500 and Brickyard to NCAA Final Four business trips to Eli Lilly and Salesforce professionals — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Marion County and Central Indiana.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20Indianapolis%20Indiana%20skyline%20with%20the%20Soldiers%20and%20Sailors%20Monument%20and%20modern%20glass%20skyscrapers%2C%20White%20River%20State%20Park%20visible%20in%20the%20foreground%2C%20warm%20golden%20sunset%20light%2C%20professional%20city%20photography%2C%20clean%20and%20vibrant%20downtown%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20warm%20tones%20and%20architectural%20details&width=1800&height=700&seq=indianapolis-hero-001&orientation=landscape",
  heroImageAlt: "Indianapolis Indiana skyline with Soldiers and Sailors Monument and downtown skyscrapers",
  geoPosition: "39.7684;-86.1581",
  geoPlacename: "Indianapolis, Indiana",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Indianapolis Passport Agency",
    address: "4419 Indiana Ave, Indianapolis, IN 46221",
    distance: "Located in Indianapolis — local to all Marion County residents",
  },
  nearbyCitiesZips: [
    { name: "Indianapolis", zips: "46201, 46202, 46203, 46204, 46205, 46206, 46208, 46214, 46217, 46218, 46219, 46220, 46221, 46222, 46224, 46225, 46226, 46227, 46228, 46229, 46231, 46234, 46235, 46236, 46237, 46239, 46240, 46241, 46250, 46254, 46256, 46259, 46260, 46268, 46278, 46280, 46290" },
    { name: "Carmel", zips: "46032, 46033, 46074, 46082" },
    { name: "Fishers", zips: "46037, 46038, 46040, 46085" },
    { name: "Noblesville", zips: "46060, 46061, 46062" },
    { name: "Greenwood", zips: "46142, 46143, 46184" },
    { name: "Westfield", zips: "46033, 46074, 46075" },
    { name: "Zionsville", zips: "46077, 46068" },
    { name: "Avon", zips: "46123, 46234" },
    { name: "Plainfield", zips: "46168, 46122, 46234" },
    { name: "Brownsburg", zips: "46112" },
    { name: "Lawrence", zips: "46226, 46236, 46256" },
    { name: "Beech Grove", zips: "46107" },
    { name: "Speedway", zips: "46224, 46214" },
    { name: "Franklin", zips: "46131" },
    { name: "Greenfield", zips: "46140" },
    { name: "Anderson", zips: "46011, 46012, 46013, 46014, 46015, 46016, 46017, 46018" },
    { name: "Muncie", zips: "47302, 47303, 47304, 47305, 47306, 47307" },
    { name: "Terre Haute", zips: "47801, 47802, 47803, 47804, 47805, 47807, 47808, 47809" },
    { name: "Lafayette", zips: "47901, 47902, 47903, 47904, 47905, 47909" },
    { name: "Bloomington", zips: "47401, 47403, 47404, 47405, 47406, 47408" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier service to the Indianapolis Passport Agency — the only local passport agency in Indiana" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Indy Sports & Business Hub", desc: "Serving Indy 500, Brickyard, NCAA, Eli Lilly, and Salesforce travelers" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — no trip to the agency required" },
  ],
  internalLinks: [
    { name: "Expedited passport in Carmel, IN", route: "/cities/carmel" },
    { name: "Emergency passport help in Fort Wayne, IN", route: "/cities/fort-wayne" },
    { name: "Urgent passport services in Evansville, IN", route: "/cities/evansville" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Indianapolis, Indiana via secure registered courier to the Indianapolis Passport Agency (4419 Indiana Ave, Indianapolis). The only local passport agency in Indiana — no long drive to Chicago or Detroit required. We can hand-deliver in person or ship overnight from any UPS or FedEx in Marion County.",
  fpcOfficeDistance: "Serving Indianapolis, Carmel, Fishers, Noblesville, Greenwood, Westfield, Zionsville, Avon, Plainfield, Brownsburg, Lawrence, Beech Grove, Speedway, and all of Central Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Indianapolis and Central Indiana. From downtown Indy near the Convention Center to the Carmel Arts & Design District, from Fishers and Noblesville to Greenwood and Avon — we serve all of Marion County, Hamilton County, and beyond.",
  nearbyCitiesIntro: "We serve Indianapolis and all nearby communities including Carmel, Fishers, Noblesville, Greenwood, Westfield, Zionsville, Avon, Plainfield, Brownsburg, Lawrence, Beech Grove, Speedway, Franklin, Greenfield, Anderson, Muncie, Terre Haute, Lafayette, and Bloomington. We also serve all of Central Indiana and the greater Indianapolis metropolitan area.",
  howItWorksIntro: "Most Indianapolis travelers complete everything online and ship documents overnight. Because the Indianapolis Passport Agency is LOCAL, we can often hand-deliver the same day — faster than any other Indiana city.",
  mistakesIntro: "Indianapolis is Indiana's travel capital — with massive sports tourism (Indy 500, Brickyard, NCAA), Eli Lilly international business travel, and Salesforce regional flights. Here are the most common passport mistakes we see from Marion County and Central Indiana travelers.",
  testimonialsIntro: "Indianapolis travelers — from Indy 500 fans to corporate professionals to Hoosier families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Indianapolis, IN? Here are the most common ones we hear from Central Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Indianapolis Passport Agency in person", "Full day commitment — but no long drive needed"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Indianapolis Passport Agency — local hand delivery", "No long drive required — only city in Indiana with this advantage", "Perfect for Indy 500, Brickyard, and business travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Indianapolis Passport Agency — local hand delivery", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Indianapolis travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Indianapolis Passport Agency — the only local passport agency in Indiana.",
      bullets: ["24–48 hour turnaround available", "Indianapolis Passport Agency — local hand delivery", "Indy 500, Brickyard, and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Indianapolis adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Central Indiana address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Indianapolis residents and families — including IUPUI students, new citizens, and Central Indiana families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Indianapolis residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Indianapolis and Central Indiana families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Indianapolis and Central Indiana residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Indianapolis IN", description: "Urgent passport processing for Indianapolis Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Indianapolis IN", description: "Fast passport renewal for Indianapolis Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Indianapolis IN", description: "New passport application services for Indianapolis Indiana residents applying for their first passport." },
    { name: "Child Passport Indianapolis IN", description: "Minor passport services for Indianapolis Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Michael T.",
      location: "Carmel, IN",
      rating: 5,
      text: "Conference in Geneva in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. The Indianapolis Passport Agency is literally in our city — this service is a game changer. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Jennifer K.",
      location: "Fishers, IN",
      rating: 5,
      text: "Family trip to Cancun with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 4 days. We shipped from FedEx on Keystone and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "David R.",
      location: "Indianapolis, IN",
      rating: 5,
      text: "Business trip to London with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Being able to hand-deliver to the Indianapolis Passport Agency is a huge advantage.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah L.",
      location: "Greenwood, IN",
      rating: 5,
      text: "Lost my passport the week before a study abroad semester in Italy. Fast Passport Center replaced it in 48 hours. As an IUPUI student, I couldn't afford to miss my program. They saved my semester.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "indy-1",
      name: "Indianapolis Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "150 N Alabama St",
      city: "Indianapolis",
      state: "IN",
      zip: "46204",
      phone: "(317) 631-5551",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Indianapolis, near Circle Centre",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary downtown Indianapolis acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown office workers and IUPUI campus.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-2",
      name: "Carmel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2750 E 146th St",
      city: "Carmel",
      state: "IN",
      zip: "46033",
      phone: "(317) 846-3504",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Carmel, approximately 20 miles north of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Carmel, Fishers, and northern Hamilton County residents. Ample parking available.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-3",
      name: "Greenwood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "167 W Main St",
      city: "Greenwood",
      state: "IN",
      zip: "46142",
      phone: "(317) 888-2234",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Greenwood, approximately 12 miles south of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Greenwood, Franklin, and southern Johnson County residents. Good alternative for south-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-4",
      name: "Fishers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11601 Municipal Dr",
      city: "Fishers",
      state: "IN",
      zip: "46038",
      phone: "(317) 579-5251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fishers, approximately 18 miles northeast of downtown Indianapolis",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Fishers and northeastern Hamilton County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "indy-5",
      name: "Marion County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "200 E Washington St",
      city: "Indianapolis",
      state: "IN",
      zip: "46204",
      phone: "(317) 327-4010",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Indianapolis City-County Building",
      website: "https://www.indy.gov/agency/marion-county-clerk",
      websiteLabel: "Marion County Clerk",
      notes: "County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, appointment required", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — but local in Indianapolis", fpc: "No — we deliver for you" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Local Advantage", agency: "Indianapolis only city in Indiana with agency", fpc: "We leverage this local advantage for all clients" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Indianapolis sports fans and business travelers often discover passport issues just before Indy 500, Brickyard, or international conferences. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Monument Circle or Castleton Square sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Marion County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Indianapolis Post Office appointments fill during Indy 500 season (May), summer travel, and NCAA tournament season. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-calendar-line",
      title: "Assuming Indy 500 Doesn't Require International Travel",
      description: "Many Indy 500 attendees fly to European F1 races or Caribbean getaways. The 500 season is peak passport demand in Indianapolis — plan accordingly.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring break and summer travel peaks March through August.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Indianapolis area or Central Indiana." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near Monument Circle, Castleton, or Carmel." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Indianapolis Passport Agency — the only local passport agency in Indiana." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Indianapolis address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Indianapolis, IN?", a: "Fast Passport Center offers emergency passport processing in Indianapolis, Indiana in as little as 24–48 hours. Because Indianapolis has the only local passport agency in Indiana (4419 Indiana Ave, Indianapolis), our registered couriers can hand-deliver your documents — no long drive to Chicago or Detroit required." },
    { q: "Does Indianapolis have its own passport agency?", a: "Yes — Indianapolis is the only city in Indiana with a regional passport agency. The Indianapolis Passport Agency is located at 4419 Indiana Ave, Indianapolis, IN 46221. This is a major advantage over Fort Wayne, Evansville, South Bend, and other Indiana cities that must travel to Chicago or Detroit for emergency in-person service. Fast Passport Center leverages this local advantage for all Indianapolis-area clients." },
    { q: "Can I get an expedited passport in Carmel, Fishers, or Greenwood?", a: "Absolutely. Fast Passport Center serves all of Central Indiana including Carmel, Fishers, Noblesville, Greenwood, Westfield, Zionsville, Avon, Plainfield, Brownsburg, and all of Marion and Hamilton counties. Because we use the Indianapolis Passport Agency, all of these suburbs benefit from the same local processing advantage." },
    { q: "What airport do Indianapolis travelers use for international flights?", a: "Indianapolis International Airport (IND) is the primary airport for Indianapolis and Central Indiana. IND offers direct flights to Toronto, Cancun, and Paris (seasonal) plus connecting service worldwide through major hubs. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Indianapolis, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Indianapolis?", a: "Walgreens, CVS, and Walmart stores throughout Indianapolis, Carmel, and Fishers offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Eli Lilly and Salesforce employees?", a: "Yes. Fast Passport Center serves all of Central Indiana including major corporate campuses in the Indianapolis area. We understand international business travel deadlines and conference schedules. Our Indianapolis Passport Agency access is especially valuable for last-minute corporate travel needs." },
    { q: "Is Indianapolis the only city in Indiana with a passport agency?", a: "Yes. The Indianapolis Passport Agency is the only regional passport agency in Indiana. Fort Wayne, Evansville, South Bend, and other Indiana cities must travel to Chicago or Detroit for emergency in-person service. This gives Indianapolis-area travelers a unique local advantage." },
  ],
  photoLocations: [
    { name: "Walgreens — Meridian Indianapolis", address: "5350 N Meridian St, Indianapolis, IN 46208", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walgreens — Castleton", address: "8235 Center Run Dr, Indianapolis, IN 46250", hours: "Mon–Sun: 7AM–10PM" },
    { name: "UPS Store — Carmel", address: "14100 N River Rd, Carmel, IN 46033", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Downtown Indianapolis", address: "1 N Pennsylvania St, Indianapolis, IN 46204", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Indianapolis South", address: "1414 W Morris St, Indianapolis, IN 46221", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended.", featured: true },
    { name: "Indiana BMV — Carmel", address: "14560 River Rd, Carmel, IN 46033", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Carmel, Fishers, and northern Hamilton County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "7 miles southwest of downtown Indianapolis via I-70",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Indianapolis and Central Indiana. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3 hours northwest of Indianapolis via I-65",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Indianapolis travelers seeking more international routes. United and American Airlines hub with global connections.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "Approximately 2 hours southeast of Indianapolis via I-74",
      address: "2939 Terminal Dr, Hebron, KY 41048",
      note: "Alternative airport for Indianapolis travelers. Delta hub with domestic and international connections.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Flight Info",
      featured: false,
    },
  ],
};